import React from "react";
import { createRoot } from "react-dom/client";
import { AppProvider } from "./index.jsx";

createRoot(document.getElementById("root")!).render(<AppProvider />);
